export default Object.freeze({
  Assistant: 1,
  ProcessActionTypeOpenAI: 2,
  ProcessActionTypeAutomyAI: 3,
});
